/* global isAddressValidationEnabled, showAddressValidationOverlay, invalidAddress, customerShippingAddressList, deliveryAddressFormHasErrors */
import modal from '../components/modal';
import { logError } from '../services/sentryService';
import { focusAccessibleAlert } from '../utils/index';
import { AddressSuggestion } from './addressSuggestion';

let SHIPPING = {};
const shippingAddressBtnClass = '.js-deleteShippingAddress';
const addAddressBtnClass = '.js-addNewAddress';
const editPreferredAddressBtnClass = '.js-edit-preferredAddress';
const editAddressBtnClass = '.js-edit-shippingAddress';
const validationErrorMessage = '.js-validationProblemError';
const deliveryFormModalClass = '.delivery-address-form-modal';
const jsModalServerErrorClass = 'js-modal-form-server-error';
const noAddressSuggestion = 'no-address-suggestion';
const ADD_NEW_ADDRESS_ACTION = 'addNewAddress';
const EDIT_OLD_ADDRESS_ACTION = 'editOldAddress';
const EDIT_PREFERRED_ADDRESS_ACTION = 'editPreferredAddress';
const NEW_FORM_FIELD_PREFIX = 'shippingAddress';
const PREFERRED_FORM_FIELD_PREFIX = 'preferredShippingAddress';

let addressType = '';
let deliveryAddressHasNoSuggestion = false;

const Action = {
  CANCEL: 'CANCEL',
};

SHIPPING.init = function () {
  let location = window.location.pathname;
  addressType = location.includes('editShippingAddress')
    ? 'delivery'
    : location.includes('editaddress')
    ? 'invoice'
    : '';
  if (addressType === 'delivery') {
    removeShippingAddressHandler();
    initDeliveryAddressForm();
    focusAccessibleAlert();
  }

  if (
    addressType === 'delivery' &&
    isAddressValidationEnabled &&
    showAddressValidationOverlay
  ) {
    AddressSuggestion.check(addressType);
  }
};

const handleAddressFormData = (callbackData) => {
  const { action } = callbackData;
  if (action === Action.CANCEL) {
    modal.disposeModal($(deliveryFormModalClass));
  }
};

const handleDeliveryAddressFormErrors = (params) => {
  const errorObject = { hasServerError: true };
  const {
    hiddenFields: { actionPerformed },
  } = params;
  if (
    actionPerformed === EDIT_PREFERRED_ADDRESS_ACTION &&
    deliveryAddressHasNoSuggestion
  ) {
    errorObject['errorCode'] = noAddressSuggestion;
    params['error'] = errorObject;
  }
  if (deliveryAddressFormHasErrors) {
    errorObject['hasValidationError'] = invalidAddress;
    params['error'] = errorObject;
  }
};

const initDeliveryAddressForm = () => {
  $(editPreferredAddressBtnClass)
    .add($(addAddressBtnClass))
    .add($(editAddressBtnClass))
    .on('click', (event) => {
      event.preventDefault();

      if (typeof window.DeliveryAddressForm !== 'object') {
        logError('DeliveryAddressForm JS is not properly loaded.');
        return;
      }

      const deliveryAddressFormParams = getDeliveryAddressFormParams(event);
      handleDeliveryAddressFormErrors(deliveryAddressFormParams);
      window.DeliveryAddressForm.render(deliveryAddressFormParams);

      const onClose = () => {
        // Reload the page if the user closes the form when a validation or server error occurred
        if (deliveryAddressFormHasErrors) {
          window.location.replace(window.location.href);
        }
      };
      modal.openModal($(deliveryFormModalClass), null, onClose);
    });

  // Open form with generic error message
  const serverErrorSelector = $(`.${jsModalServerErrorClass}`);
  if (serverErrorSelector.length > 0) {
    serverErrorSelector.trigger('click');
  }
};

const getDeliveryAddressFormParams = (event) => {
  const params = getDeliveryFormDefaultParams();
  const performedAction = getCustomerPerformedAction(event);
  if (performedAction === ADD_NEW_ADDRESS_ACTION) {
    return params;
  }

  const selectedDeliveryAddress = getSelectedDeliveryAddress(event);
  params['defaultValues'] = { ...selectedDeliveryAddress };
  params.hiddenFields['actionPerformed'] = performedAction;

  let fieldNamePrefix = PREFERRED_FORM_FIELD_PREFIX;
  let addressIdFieldName = 'shippingAddressId';
  if (performedAction === EDIT_OLD_ADDRESS_ACTION) {
    fieldNamePrefix = `shippingAddresses[${selectedDeliveryAddress.index}].customerAddress`;
    addressIdFieldName = 'selectedShippingAddressId';
  }

  params.hiddenFields[addressIdFieldName] = selectedDeliveryAddress.id;
  params.formAttributes['fieldNamePrefix'] = fieldNamePrefix;
  return params;
};

const getSelectedDeliveryAddress = (event) => {
  const shippingAddressId = $(event.currentTarget).data('shippingAddressId');
  return customerShippingAddressList[shippingAddressId] || {};
};

const getDeliveryFormDefaultParams = () => {
  const EDIT_SHIPPING_ADDRESS_PATH_IN_CHECKOUT =
    '/checkout/editShippingAddress';
  const EDIT_SHIPPING_ADDRESS_PATH_IN_MY_DATA =
    '/account/customer/editShippingAddress';
  const urlPathname = window.location.pathname;
  const formSubmitUrl =
    EDIT_SHIPPING_ADDRESS_PATH_IN_MY_DATA === urlPathname
      ? EDIT_SHIPPING_ADDRESS_PATH_IN_MY_DATA
      : EDIT_SHIPPING_ADDRESS_PATH_IN_CHECKOUT;

  return {
    elementId: 'delivery-address-form-container',
    hiddenFields: {
      actionPerformed: ADD_NEW_ADDRESS_ACTION,
      selectedType: 'NORMAL_ADDRESS',
      'X-CSRF-Token': window.csrfToken,
    },
    formAttributes: {
      action: formSubmitUrl,
      fieldNamePrefix: NEW_FORM_FIELD_PREFIX,
    },
    defaultValues: { sameAsShipping: true },
    callback: handleAddressFormData,
  };
};

const getCustomerPerformedAction = (event) => {
  const customerActionsObj = {
    'js-addNewAddress': ADD_NEW_ADDRESS_ACTION,
    'js-edit-preferredAddress': EDIT_PREFERRED_ADDRESS_ACTION,
    'js-edit-shippingAddress': EDIT_OLD_ADDRESS_ACTION,
  };

  for (const actionClass of Object.keys(customerActionsObj)) {
    if (event.currentTarget.classList.contains(actionClass)) {
      return customerActionsObj[actionClass];
    }
  }
  return ADD_NEW_ADDRESS_ACTION;
};

const openDeliveryAddressFormInEditMode = () => {
  $(editPreferredAddressBtnClass).trigger('click');
};
/**
 * Set error message on form and set the cookie for the next request.
 * Open edit modal only for shipping address
 */
export const setFailedAddressValidationState = () => {
  $(validationErrorMessage).removeClass('hidden');
  $('#js-updateUniservInfo').val(true);
  deliveryAddressHasNoSuggestion = true;
  openDeliveryAddressFormInEditMode();
};

export const showEditAddressForm = () => {
  openDeliveryAddressFormInEditMode();
};

function removeShippingAddressHandler() {
  $('button' + shippingAddressBtnClass).click(function (e) {
    e.preventDefault();
    let $currentForm = $(this).parent('form');
    let $actionPerformed = $currentForm.find('input[name=actionPerformed]');
    $actionPerformed.val('deleteAddress');
    $currentForm.submit();
    $(this).attr('disabled', 'disabled');
  });
}

export default SHIPPING;
